<template>
    <a href="https://twitch.tv/thoulessart" target="_blank" v-if="live_data" :class="{'live': live_data, 'bar': true}">
        <div v-if="live_data">
             <i class="nf nf-fa-twitch"></i> I am currently live on Twitch <span class="viewers"><i class="nf nf-oct-person"></i> {{live_data.viewer_count}}</span>
        </div>
    </a>
</template>

<script>
    const axios = require('axios')

    export default {
        data() {
            return {
                live_data: null
            }
        },
        async mounted() {
            // axios.defaults.headers.common['Client-ID'] = 'y9tdth66xkwb4geou6nlk4aqhc53rq';

            // const res = await axios.get('https://api.twitch.tv/helix/streams?user_id=124426703')

            // const data = res.data.data;

            // if(data.length > 0) {
            //     const live_data = data[0]

            //     this.live_data = live_data;
            // }
        }
    }
</script>

<style lang="scss" scoped>
    .bar {
        width: 100%;
        height: 50px;
        position: absolute;
        top: 0;

        text-align: center;
        line-height: 50px;

        color: #FFF;
        background-color: rgba(225, 35, 35, 0.9);
        z-index: 100;
    }

    a {
        color: #FFF;
        text-decoration: none;
        font-family: inherit;
        font-weight: bold;
    }

    .live {
        background-color: #6441a5;

        i {
            padding-right: 5px;
        }

        .viewers {
            padding-left: 5px;
            color: #ff4e20;
            font-family: inherit;
            font-weight: bold;
        }
    }
</style>